<template>
  <p>
    Esta acción permite establecer un período de tiempo específico antes de llevar a cabo la
    siguiente acción en la secuencia. Es útil para programar pausas entre las interacciones con los
    contactos.
  </p>

  <a-form layout="vertical" ref="formRef" :model="formState">

    <a-form-item
      name="waiting_time"
      required
      :rules="rulesWaitingTime"
    >
    <!-- <a-form-item name="waiting_time" label="Tiempo de espera (hh:mm)" required> -->
      <!-- <a-time-picker
        class="picker"
        v-model:value="formState.waiting_time"
        placeholder="03:30"
        format="HH:mm"
        valueFormat="HH:mm:ss"
        :disabled="disabled"
      /> -->
      <TimePicker v-model:value="formState.waiting_time" :disabled="disabled" />
    </a-form-item>

    <ActionPicker
      v-if="formState.action"
      v-model:value="formState.action"
      :disabled="disabled"
      :is-multichannel="sequence.sequence_type == SequenceType.Multichannel"
      :sequence="sequence"
    />
  </a-form>
</template>

<script setup lang="ts">
import { ref, watch, inject, Ref } from "vue";
import { FormInstance } from "ant-design-vue";

import { Sequence, SequenceNode } from "@/@types/flows/sequences";

import ActionPicker from "@/app/flows/sequences/components/pickers/ActionPicker.vue";
import TimePicker from "@/app/shared/components/pickers/TimePicker.vue";
import { SequenceType } from "@/app/flows/sequences/utils/enums";

const props = defineProps<{ node: SequenceNode; disabled: boolean; sequence: Sequence }>();
const saveDisabled = inject("saveDisabled") as Ref<Boolean>;

const formRef = ref<FormInstance>();
const formState = ref<Partial<SequenceNode>>({
  waiting_time: props.node.waiting_time,
  action: props.node.action,
});

watch(
  () => formState.value,
  (lastValue, newValue) => {
    if (lastValue && newValue) {
      saveDisabled.value = false;
    }
  },
  { deep: true, immediate: true }
)

watch(
  () => props.node,
  () => {
    formState.value = {
      waiting_time: props.node.waiting_time,
      action: props.node.action,
    };
  }
)

const rulesWaitingTime = [
  {
    validator: (rule, value) => {
      if (!value) return Promise.resolve();
      const [hours, minutes] = value.split(':');
      if (Number(hours) > 168 || (Number(hours) === 168 && Number(minutes) > 0)) {
        return Promise.reject('El tiempo máximo de espera es de 168 horas');
      }
      return Promise.resolve();
    }
  }
];

const getValidatedFormState = async () => {
  await formRef.value?.validateFields();

  return formState.value;
};

defineExpose({ getValidatedFormState });
</script>

<style scoped lang="sass">
p
  color: $text-primary
  margin-bottom: 24px

h2
  color: $text-primary
  font-size: 16px
  font-weight: 600
  margin-bottom: 12px

.picker
  width: 100%
</style>
